import { default as messages } from "./messages";

const availableStrings = {
  ...messages,
};

export function message(key: string, replacements?: Record<string, string>) {
  let str = availableStrings[key];

  if(replacements) {
    Object.keys(replacements).forEach(placeholder => {
      str = str.replace(`:${placeholder}:`, replacements[placeholder]);
    });
  }

  return str;
}
